export const PATHWAY_EDITOR_SCREENS = ['pathwayEditor', 'Screens'];
export const PLATFORM_SCOPE = 'PLATFORM_SCOPE';
export const PLUGIN_SCOPE = 'PLUGIN_SCOPE';
